import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { useIsDesktop } from '@alfalab/core-components-mq/esm';
import { InputDesktop } from './desktop/Component.desktop.js';
import { InputMobile } from './mobile/Component.mobile.js';

var Input = forwardRef(function (_a, ref) {
    var breakpoint = _a.breakpoint, client = _a.client, _b = _a.defaultMatchMediaValue, defaultMatchMediaValue = _b === void 0 ? client === undefined ? undefined : client === 'desktop' : _b, restProps = __rest(_a, ["breakpoint", "client", "defaultMatchMediaValue"]);
    var isDesktop = useIsDesktop(breakpoint, defaultMatchMediaValue);
    var Component = isDesktop ? InputDesktop : InputMobile;
    return React.createElement(Component, __assign({ ref: ref }, restProps));
});
Input.displayName = 'Input';

export { Input };
